import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff6fb0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-statistics" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Times que participo", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "team__names" }
const _hoisted_5 = { class: "team__name" }
const _hoisted_6 = { class: "team__manager" }
const _hoisted_7 = { class: "team__members" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.teams.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "team",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(team.name), 1),
                _createElementVNode("span", _hoisted_6, "Gestor: " + _toDisplayString(team.managerName), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_7, "Membros: " + _toDisplayString(team.totalOfMembers), 1)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, "Você não está participando de nenhum time no momento."))
  ]))
}